import React from "react";
import { HiOutlineExclamationCircle, HiOutlineWifi, HiOutlineQuestionMarkCircle } from "react-icons/hi2";

const ErrorState = ({ error, statusCode, isDarkMode }) => {
  // Determine error type
  const isConnectionError = error?.toLowerCase().includes("connect") || error?.toLowerCase().includes("connection");
  const isNotFound = statusCode === 404;

  // Select appropriate icon
  let Icon = HiOutlineExclamationCircle;
  if (isConnectionError) {
    Icon = HiOutlineWifi;
  } else if (isNotFound) {
    Icon = HiOutlineQuestionMarkCircle;
  }

  // Get appropriate message and description
  let title = "Something went wrong";
  let description = "Please try refreshing the page";

  if (isConnectionError) {
    title = "Connection error";
    description = "Please check your internet connection and try again";
  } else if (error === "No automations found") {
    title = "No automations found";
    description = "Run an automation first to collect some data";
  } else if (isNotFound) {
    title = "Table not found";
    description = "This table doesn't exist or may have been deleted";
  }

  return (
    <div className="flex flex-col items-center justify-center h-full w-full absolute inset-0 p-8 text-center">
      <div className="flex flex-col items-center gap-4 max-w-sm">
        {/* Icon container */}
        <div className={`w-16 h-16 rounded-2xl flex items-center justify-center ${
          isDarkMode
            ? "bg-amber-500/[0.08] border border-amber-500/20"
            : "bg-amber-50 border border-amber-200"
        }`}>
          <Icon className={`w-8 h-8 ${isDarkMode ? "text-amber-400/80" : "text-amber-500"}`} />
        </div>

        {/* Message */}
        <div className="flex flex-col gap-1.5">
          <h3 className={`text-base font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-900"}`}>
            {title}
          </h3>
          <p className={`text-sm ${isDarkMode ? "text-gray-500" : "text-gray-500"}`}>
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ErrorState;
